import { render, staticRenderFns } from "./Kiosk.vue?vue&type=template&id=c14ab99a"
import script from "./Kiosk.vue?vue&type=script&lang=js"
export * from "./Kiosk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports